function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.27 17.19c-1 .91-2.29 1.41-3.64 1.4h-.09c.3-.62.46-1.32.46-2.06 0-2.76-2.24-5-5-5s-5 2.24-5 5c0 .74.16 1.44.46 2.06H5.54c-4.68-.33-4.68-7.14 0-7.47h.05C2.38 2.19 15.92-1.38 17.47 8c4.33.55 6.08 6.32 2.8 9.19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.53c-2.76 0-5 2.24-5 5 0 .74.16 1.44.46 2.06.08.18.17.35.27.51A4.961 4.961 0 0012 21.53c1.82 0 3.41-.98 4.27-2.43.1-.16.19-.33.27-.51.3-.62.46-1.32.46-2.06 0-2.76-2.24-5-5-5zm2.07 4.57l-2.13 1.97c-.14.13-.33.2-.51.2-.19 0-.38-.07-.53-.22l-.99-.99a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l.48.48 1.6-1.48c.31-.28.78-.26 1.06.04s.26.77-.04 1.06z"
})));